// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a820cc38","455":"37ca723a","977":"d815fc32"}[chunkId] + ".chunk.js";
};